import React from "react";
import RowStatusIndicator from "../../RowStatusIndicator/RowStatusIndicator";
import TableCellRenderer from "./TableCellRenderer/TableCellRenderer";
import "./ProductTableRow.css";
import { toast } from "react-toastify";


const ProductTableRow = ({
  product,
  fields,
  dropdownData,
  selectedProducts,
  handleSelect,
  handleCellClick,
  editingCell,
  editedValue,
  setEditedValue,
  setEditingCell,
  pendingChanges,
  setPendingChanges,
  user,
  status,
  canEditRow,
  FileUploadButton,
  NumberPartsEditor,
  renderField,
  handleContextMenu,
  currentProducts,
  getDisplayLabel,
  updatePendingChanges,
  handleDoubleClick,
  roleCompare,
}) => {
  const edittableFields = React.useMemo(() => {
    return Array.isArray(user?.fieldsAccess)
      ? fields
          .map((f) => f.fields?.toString())
          .filter((field) => user.fieldsAccess.includes(field))
      : [];
  }, [fields, user?.fieldsAccess]);

  const isRowEditable = canEditRow(product, user, roleCompare);

  const handlePopupSuccess = (newEntry) => {
    const newId = newEntry?._id || newEntry;
    if (!newId || !editingCell?.fieldName || !product?._id) return;

    const fieldName = editingCell.fieldName;
    const field = fields.find((f) => f.fields === fieldName);
    if (!field) return;

    const currentValue = product[fieldName];
    const isMulti = field.multiple;

    // Extract existing IDs from field
    const currentIds = Array.isArray(currentValue)
      ? currentValue
          .filter(Boolean)
          .map((val) => (typeof val === "object" ? val._id : val))
      : [];

    const alreadyExists = currentIds.includes(newId);
    const updatedValue = isMulti
      ? alreadyExists
        ? currentIds
        : [...currentIds, newId]
      : newId;

    // Update pendingChanges map
    updatePendingChanges(
      product._id,
      fieldName,
      updatedValue,
      setPendingChanges
    );

    // Optionally update local product object or state if needed
    // (skip if you're showing from products directly)

    // Close the popup
    setEditingCell(null);

    console.log("✅ Updated pendingChanges with:", updatedValue);

    toast.success(`✅ New ${field.title || fieldName} linked successfully.`);
  };

  return (
    <tr
      className="advanceProduct-table-row"
      onContextMenu={(e) => {
        e.preventDefault();
        handleContextMenu?.(e, product);
      }}
    >
      <td className="row-checkbox-cell">
        <input
          type="checkbox"
          className="row-checkbox"
          checked={selectedProducts.includes(product._id)}
          onChange={() => handleSelect(product._id)}
        />
      </td>

      {product?.status && typeof product.status === "object" && (
        <td className="row-status-cell">
          <RowStatusIndicator product={product} status={product.status} />
        </td>
      )}

      {fields
        .filter(
          (field) => !["password", "plainPassword"].includes(field.fields)
        )
        .map((field, index) => (
          <TableCellRenderer
            key={`${product._id}-${field.fields}-${index}`}
            product={product}
            field={field}
            value={
              pendingChanges?.[product._id]?.[field.fields] ??
              product[field.fields]
            }
            isEditable={edittableFields.includes(field.fields) && isRowEditable}
            dropdownData={dropdownData}
            editingCell={editingCell}
            editedValue={editedValue}
            setEditedValue={setEditedValue}
            setEditingCell={setEditingCell}
            setPendingChanges={setPendingChanges}
            pendingChanges={pendingChanges}
            FileUploadButton={FileUploadButton}
            NumberPartsEditor={NumberPartsEditor}
            renderField={renderField}
            handleCellClick={handleCellClick}
            getDisplayLabel={getDisplayLabel}
            updatePendingChanges={updatePendingChanges}
            handleDoubleClick={handleDoubleClick}
            currentProducts={currentProducts}
            handlePopupSuccess={handlePopupSuccess}

          />
        ))}
    </tr>
  );
};

export default ProductTableRow;
